import { render, staticRenderFns } from "./LatestMovie.vue?vue&type=template&id=365def59&"
import script from "./LatestMovie.vue?vue&type=script&lang=js&"
export * from "./LatestMovie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports